export const MAILCHIMP_NOT_SET = 'not-set';
export const SET_MAILCHIMP_STATE = 'SET_MAILCHIMP_STATE';
export const GET_MAILCHIMP_SETTINGS = 'GET_MAILCHIMP_SETTINGS';
export const GET_MAILCHIMP_SETTINGS_ERROR = 'GET_MAILCHIMP_SETTINGS_ERROR';
export const SAVE_MAILCHIMP_SETTINGS = 'SAVE_MAILCHIMP_SETTINGS';
export const MAILCHIMP_REDIRECT_PATH = '/mailchimp-auth';
